import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import TranscriptPlayer from "./widgets/TranscriptPlayer";
import LoadingSpinner from "./widgets/LoadingSpinner";
import { DEPLOYMENT_CONFIG } from "../../../config/deployment";

const StandaloneCallPage = () => {
  const [searchParams] = useSearchParams();
  const [callsummary, setCallsummary] = useState("");
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  // Get URLs from query params
  const audioUrl = searchParams.get("audioUrl") || "";
  const transcriptUrl = searchParams.get("transcriptUrl") || "";
  const callsummaryParam = searchParams.get("callsummary") || "";
  const transcriberHref = searchParams.get("transcriberHref") || "";
  const transcriberTitle = searchParams.get("transcriberTitle") || "";
  const callRecordHref = searchParams.get("callRecordHref") || audioUrl;
  const callRecordTitle = searchParams.get("callRecordTitle") || "Recording";
  // Shareable link logic (match dashboard)
  const basePath = DEPLOYMENT_CONFIG.getCurrentPath();
  const params = new URLSearchParams({
    audioUrl,
    transcriptUrl,
    callsummary: callsummaryParam,
    transcriberHref,
    transcriberTitle,
    callRecordHref,
    callRecordTitle,
  });
  const shareableLink = `${window.location.origin}${basePath}/call?${params.toString()}`;

  useEffect(() => {
    // Check if user is logged in (token in localStorage)
    const token = localStorage.getItem('token');
    if (!token) {
      // Redirect to login with redirect param
      const currentUrl = window.location.pathname + window.location.search;
      navigate(`/login?redirect=${encodeURIComponent(currentUrl)}`);
      return;
    }
    setCallsummary(callsummaryParam);
    setUser({}); // Just a flag to render TranscriptPlayer
    setLoading(false);
  }, [callsummaryParam, navigate]);

  const handleClose = () => {
    // Redirect to dashboard (trainee or admin)
    const userRole = localStorage.getItem('userRole');
    if (userRole === 'admin') {
      navigate('/admin-dashboard');
    } else {
      navigate('/trainee-dashboard');
    }
  };

  if (loading) {
    return <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'50vh'}}><LoadingSpinner /> Loading call...</div>;
  }

  if (!user) return null;

  return (
    <div style={{ minHeight: '100vh', background: '#f7fafd', padding: '40px 0', position: 'relative' }}>
      {/* Large faded label on the left */}
      <div style={{
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        width: '50vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 0,
      }}>
        <span style={{
          fontSize: 48,
          fontWeight: 700,
          color: '#1a2233',
          opacity: 0.10,
          letterSpacing: 1,
          userSelect: 'none',
          textAlign: 'center',
        }}>
          Call Recording Viewer
        </span>
      </div>
      {/* Sidebar overlay for call review */}
      {sidebarOpen &&
        TranscriptPlayer &&
        require("react-dom").createPortal(
          <TranscriptPlayer
            audioUrl={audioUrl}
            transcriptUrl={transcriptUrl}
            callsummary={callsummary}
            onClose={handleClose}
            transcriberHref={transcriberHref}
            transcriberTitle={transcriberTitle}
            callRecordHref={callRecordHref}
            callRecordTitle={callRecordTitle}
            shareableLink={shareableLink}
          />,
          document.body
        )}
    </div>
  );
};

export default StandaloneCallPage;
